import Vue from 'vue'
import VueI18n from 'vue-i18n'
import 'element-ui/lib/theme-chalk/index.css'
import Element from 'element-ui'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN' // element-ui lang
import enLocale from './../lang/en.js'
import zhLocale from './../lang/zh.js'
Vue.use(VueI18n)
const messages = {
	en_US: {
		...enLocale,
		...elementEnLocale
	},
	zh_CN: {
		...zhLocale,
		...elementZhLocale
	}
}

// 得到本地语言环境 默认中文环境
function getLanguage() {
	const JsSrc = (navigator.language || navigator.browserLanguage).toLowerCase()
	let ReStr = 'zh_CN'
	if (JsSrc.indexOf('zh') >= 0) {
		ReStr = localStorage.getItem('language') ? localStorage.getItem('language') : 'zh_CN'
	} else if (JsSrc.indexOf('en') >= 0) {
		ReStr = localStorage.getItem('language') ? localStorage.getItem('language') : 'en_US'
	}
	localStorage.setItem('language', ReStr)
	return ReStr
}


const i18n = new VueI18n({
	locale: getLanguage(),
	messages
})

Vue.use(Element, {
	size: 'small',
	zIndex: 3000,
	i18n: (key, value) => i18n.t(key, value)
});

export default i18n